import { reactive } from 'vue'

const toasts = reactive([])
let idCounter = 0

const removeToast = (id) => {
    const index = toasts.findIndex((toast) => toast.id === id)
    if (index !== -1) {
        toasts.splice(index, 1)
    }
}

const showToast = (options) => {
    const id = idCounter++
    const toast = {
        id,
        ...options,
    }
    toasts.push(toast)
}

export function useToast() {
    return {
        toasts,
        showToast,
        removeToast,
    }
}